/**
 * Rocnovel 品牌 - Member 页面配置
 */
import { memberCommonConfig } from './common'
import type { MemberPageConfig } from './types'

/**
 * Rocnovel 品牌特定主题配置
 */
export const theme = {
  // 头像边框色 (Rocnovel 使用 #F5F2FF)
  avatarBorder: '#F5F2FF',
  // 按钮背景色 (Rocnovel 使用 #F3EEFF)
  btnPrimaryBg: '#F3EEFF',
  // VIP 背景图 URL
  vipSubscribeBg: 'url(/images/rocnovel/member_subscribe_bg.webp)',
} as const

/**
 * Rocnovel 品牌特定资源配置
 */
export const resources = {
  // 用户背景图
  userBg: '/images/rocnovel/user-bg.webp',
  // 用户默认头像
  userDefaultAvatar: '/images/rocnovel/user-default.png',
  // VIP 图标
  memberVip: '/images/rocnovel/member-vip.png',
  // VIP 折扣图标
  memberVipDiscount: '/images/rocnovel/member-vip-discount.png',
} as const

export const memberConfig: MemberPageConfig = {
  theme,
  resources,
  texts: memberCommonConfig.texts,
}
